import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from '@shared/axios-shared';
import App from './App';
import session from './session';
import './styles/index.css';

axios.defaults.baseURL = import.meta.env.VITE_API_ENDPOINT;

// Re-attach the session token (page reloads, 3DS returns).
session.restore();

// A 401 means the 60-min hosted session died mid-visit: drop the session and
// let the active flow route back to verify (or a dead end for webview entry).
axios.interceptors.response.use(
	(response) => response,
	(err) => {
		if (err?.response?.status === 401) {
			session.clear();
			window.dispatchEvent(new CustomEvent('pay:session-expired'));
		}
		return Promise.reject(err);
	}
);

createRoot(document.getElementById('root')).render(<App />);
